// src/services/cofounder/tools/ToolRegistry.js

const toolRegistry = [];

/**
 * Register a tool
 * @param {Object} tool
 * @param {string} tool.name
 * @param {string} tool.description
 * @param {string} tool.category - 'read' or 'write'
 * @param {Object} tool.parameters - JSON Schema for parameters
 * @param {boolean} tool.requiresConfirmation
 * @param {Function} tool.execute - async (args, context) => result
 */
export function registerTool(tool) {
  const existing = toolRegistry.findIndex(t => t.name === tool.name);
  if (existing >= 0) {
    toolRegistry[existing] = tool;
  } else {
    toolRegistry.push(tool);
  }
}

/**
 * Get all registered tools
 * @returns {Array}
 */
export function getRegisteredTools() {
  return [...toolRegistry];
}

/**
 * Get a tool by name
 * @param {string} name
 * @returns {Object|undefined}
 */
export function getTool(name) {
  return toolRegistry.find(t => t.name === name);
}

/**
 * Get tools by category
 * @param {string} category
 * @returns {Array}
 */
export function getToolsByCategory(category) {
  return toolRegistry.filter(t => t.category === category);
}
